/**
 * Fades out the boot splash `index.html` paints ahead of the bundle (see the
 * comment on its styles there). Called once the router has resolved its first
 * route, so the splash hands over to a finished page rather than to whatever
 * the router shows while it is still deciding. Safe to call more than once.
 */
export function dismissBootSplash(): void {
  const splash = document.getElementById("boot-splash");
  if (!splash || splash.hasAttribute("data-leaving")) return;
  splash.setAttribute("data-leaving", "");
  // `transitionend` never fires if the fade is skipped (a background tab, a
  // reduced-motion setting), so the timeout is what actually guarantees removal.
  const remove = () => splash.remove();
  splash.addEventListener("transitionend", remove, { once: true });
  setTimeout(remove, 400);
}
